module.exports = __webpack_public_path__ + "img/header.97dbdc02.png";